import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

export const PaymentHistoryCard = ({
  orderData
}) => {
  const payments =
    (orderData.order_payments || [])
      .filter(payment => payment.paid);

  const formatCurrency = value => new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN'
  }).format(Number(value || 0));

  const formatDate = date => {
    if (!date) {
      return '-';
    }

    return new Date(
      date
    ).toLocaleDateString('pl-PL');
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <HistoryOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Historia transakcji
          </Typography>
        </Stack>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Data</strong>
                </TableCell>

                <TableCell>
                  <strong>Kwota</strong>
                </TableCell>

                <TableCell>
                  <strong>Numer umowy</strong>
                </TableCell>

                <TableCell>
                  <strong>Status</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payments.map(payment => (
                <TableRow
                  key={payment.id}
                >
                  <TableCell>
                    {formatDate(
                      payment.created_at
                    )}
                  </TableCell>

                  <TableCell>
                    {formatCurrency(
                      payment.to_pay
                    )}
                  </TableCell>

                  <TableCell>
                    {
                      payment.contract_number
                    }
                  </TableCell>

                  <TableCell>
                    <Chip
                      size="small"
                      color="success"
                      label={
                        payment.status_pl_name
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}

              {!payments.length && (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    align="center"
                  >
                    Brak opłaconych
                    transakcji
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
